export const selectFields = state => state.field.fields
export const selectFieldNavigationData = state => state.field.fieldNavigationData
export const selectCurrentField = state => state.field.currentField || {}
export const selectLoadingCurrentField = state => state.field.loadingCurrentField
export const selectFieldsHistory = state => state.field.fieldsHistory
export const selectFieldsPlanned = state => state.field.fieldsPlanned
export const selectFieldAnalysis = state => state.field.fieldAnalysis
export const selectCurrentFieldHistory = state => state.field.currentFieldHistory

